import React, { ReactElement } from 'react';
import ContentLoader from 'react-content-loader';
import { SKELETON } from '@utils/const';

type SimpleElementSkeletonProps = {
    width: string;
    height: string;
}

const SimpleElementSkeleton = (props: SimpleElementSkeletonProps) : ReactElement => {
    
    const {
        width,
        height
    } = props;

    return(
        <ContentLoader
            speed={SKELETON.speed}
            backgroundColor={SKELETON.backgroundColor}
            width={width}
            height={height}
        >
            <rect x="0" y="0" rx="5" ry="5" width={width} height={height} />
        </ContentLoader>
    )
}

export default SimpleElementSkeleton;
